import React, { useState, useEffect } from "react";
import AddNewEntry from "./AddNewEntry";
import { getSalesReportHeaderDetails } from "../../services/salesReportService";
import { getDistributorNames } from "../../Common/functions";

const baseTitles = [
  { title: "Today" },
  { title: "This week" },
  { title: "This month" },
  { title: "Total sales" },
];

const Header = ({
  stats,
  NewEntryButtonVisibility,
  userRole,
  setAddNewEntrySection,
}) => {
  const [openAddNewBox, setOpenAddNewBox] = useState(false);
  const [values, setValues] = useState(["0", "0", "0", "0"]);

  const getHeadersDetails = async () => {
    try {
      const payload = {
        category: "sales tracking",
        tracking_status: "Sale",
      };

      if (userRole !== "super_admin") {
        payload.distributor_name = getDistributorNames(); // Ensure this returns the correct format (e.g., array or string)
      }
      const response = await getSalesReportHeaderDetails(payload);
      const totalRecords = response?.data.total_records;
      if (totalRecords) {
        setValues([
          totalRecords.Today || 0,
          totalRecords.ThisWeek || 0,
          totalRecords.ThisMonth || 0,
          totalRecords.EntireTime || 0,
        ]);
      } else {
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
      console.error("Error fetching header details:", error);
    }
  };

  useEffect(() => {
    getHeadersDetails();
  }, []);
  // useEffect(() => {
  //   if (stats) {
  //     const initialValues = [
  //       stats.totalCustomers?.daily || 0,
  //       stats.totalSales?.daily || 0,
  //       stats.totalCustomers?.daily || 0,
  //       stats.totalCustomers?.daily || 0,
  //     ];
  //     setValues(initialValues);
  //   }

  //   const timeout = setTimeout(() => {
  //     setValues(["0", "0", "0", "6600"]);
  //   }, 12000); // 10 seconds

  //   return () => clearTimeout(timeout); // cleanup
  // }, [stats]);

  const handleAddNewEntry = () => {
    if (userRole === "distributor_admin" || userRole === "super_admin") {
      setAddNewEntrySection(true);
    }
  };
  return (
    <>
      <div className="px-0 sm:px-4 space-y-6 pt-4">
        <div className="flex justify-between gap-2">
          <h1 className="text-2xl leading-9 font-bold sm:text-3xl text-text1">
            Sales report
          </h1>
          {NewEntryButtonVisibility && (
            <div>
              <button
                className="text-white text-sm bg-primary px-3 py-2 rounded-md"
                onClick={handleAddNewEntry}
              >
                Add New
              </button>
            </div>
          )}
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-5 mb-3">
          {baseTitles.map((item, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-lg p-6 flex justify-between items-center w-full shadow-lg"
            >
              <div>
                <h2 className="text-sm font-medium text-text2 text-left">
                  {item.title}
                </h2>
                <p className="text-3xl font-bold text-text2 text-left">
                  {values[index]}
                </p>
              </div>
            </div>
          ))}
        </div>
        <hr />
      </div>
      {/* AnimatePresence ensures exit animations work */}

      {openAddNewBox && userRole === "super_admin" && (
        <AddNewEntry closeModal={() => setOpenAddNewBox(false)} />
      )}
    </>
  );
};

export default Header;
